import React from 'react';
import { AutoComplete, Button, Input, Select } from 'antd';
import { Search, X } from 'lucide-react';
import { FilterBar, FilterField } from '../../common';
import { useClientFilters } from './tableFilters.controller';

export default function TableFilters({ setRows, clientsData }) {
    const {
        channel,
        setChannel,
        asesor,
        setAsesor,
        gerente,
        setGerente,
        suggestions,
        searchValue,
        setSearchValue,
        gerentes,
        asesores,
        onSearch,
        hasActiveFilters,
        clearFilters
    } = useClientFilters({ setRows, clientsData });

    return (
        <FilterBar
            actions={
                hasActiveFilters && (
                    <Button type="text" icon={<X />} onClick={clearFilters}>
                        Limpiar
                    </Button>
                )
            }>
            <FilterField label="Buscar" className="w-full sm:w-72">
                <AutoComplete
                    value={searchValue}
                    options={suggestions.map((value) => ({ value }))}
                    onSearch={onSearch}
                    onSelect={onSearch}
                    onChange={(value) => setSearchValue(value)}
                    className="w-full">
                    <Input placeholder="Buscar cliente..." prefix={<Search className="text-surface-400" />} allowClear />
                </AutoComplete>
            </FilterField>
            <FilterField label="Canal" width={150}>
                <Select
                    value={channel}
                    onChange={setChannel}
                    options={[
                        { value: 'both', label: 'Todos' },
                        { value: 'moderno', label: 'Moderno' },
                        { value: 'tradicional', label: 'Tradicional' }
                    ]}
                />
            </FilterField>
            <FilterField label="Gerente" width={200}>
                <Select
                    value={gerente}
                    onChange={setGerente}
                    popupMatchSelectWidth={false}
                    options={[{ value: 'both', label: 'Todos' }, ...gerentes.map((value) => ({ label: value, value }))]}
                />
            </FilterField>
            <FilterField label="Asesor" width={200}>
                <Select
                    value={asesor}
                    onChange={setAsesor}
                    popupMatchSelectWidth={false}
                    options={[{ value: 'both', label: 'Todos' }, ...asesores.map((value) => ({ label: value, value }))]}
                />
            </FilterField>
        </FilterBar>
    );
}
